// Ürün Kategorileri penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.categories';

export const inventoryCategoriesGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  // Gerçek ekranda form solda, kategori listesi sağda
  mirror: true,
  title: t(`${G}.title`, 'Ürün kategorileri nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede kategori ağacını yönetirsiniz: ana kategori ve alt kategori ekler, adları düzenler, kategorileri e-ticarete açar veya silersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    form: t(`${G}.regions.form`, 'Kategori formu'),
    list: t(`${G}.regions.list`, 'Mevcut kategoriler'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Ana kategori ekleyin'),
      text: t(`${G}.s1.text`, 'Listeden bir kategori seçili değilken form "Yeni Ana Kategori Ekle" olarak açılır. Kategori adını yazın ve "Kategoriyi Ekle"ye basın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Şube Filtresi isteğe bağlıdır: şube seçerseniz liste o şubenin kategorilerine daralır ve yeni kategoriler bu şubeyle ilişkilendirilir.'),
        t(`${G}.s1.tip2`, 'Şube müdürüyseniz şube kendi şubeniz olarak sabittir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Kategori ağacını tanıyın'),
      text: t(`${G}.s2.text`, '"Mevcut Kategoriler" tablosu ana kategorileri ve altlarındaki alt kategorileri girintili gösterir; şube ve eklenme tarihi de görünür. Alt kategorisi olan satırdaki ok ile dalı açıp kapatabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'E-ticarete açık kategoriler yeşil mağaza simgesi, "E-Ticaret" etiketi ve solda yeşil çizgiyle işaretlenir.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Alt kategori için üst kategoriyi seçin'),
      text: t(`${G}.s3.text`, 'Tablodaki bir satıra ya da satırdaki + simgesine tıklayın. Form o kategorinin altına alt kategori ekleyecek şekilde değişir.'),
      tips: [
        t(`${G}.s3.tip1`, 'En fazla 3 seviye desteklenir; 3. seviyedeki bir kategoriye alt kategori eklenemez, formda uyarı görünür.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Alt kategoriyi kaydedin veya adı düzenleyin'),
      text: t(`${G}.s4.text`, 'Alt kategori adını yazıp "Alt Kategori Ekle"ye basın. Alt kategorinin şubesi üst kategoriden otomatik alınır, değiştirilemez. Seçili kategorinin adını değiştirmek için alttaki "Mevcut Kategori Adını Düzenle" bölümüne yeni adı yazıp "Kategori Adını Güncelle"ye basın.'),
      tips: [
        t(`${G}.s4.tip1`, 'Vazgeçmek için "Seçimi Temizle"ye basın; form ana kategori ekleme moduna döner.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Kategoriyi e-ticarete açın veya kaldırın'),
      text: t(`${G}.s5.text`, 'Satırdaki "E-Ticarete Aç" düğmesi kategoriyi web sitesinde görünür yapar. "E-Ticaretten Kaldır" ile kategori yayından düşer.'),
      tips: [
        t(`${G}.s5.tip1`, 'Pencere bir satış ekranından açıldıysa ek "Satış" sütunu görünür: "Ekle" ile kategoriyi o deponun satış listesine eklersiniz, eklenmişse "Ekli" yazar.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s6.title`, '6. Kategori silme kontrolleri'),
      text: t(`${G}.s6.text`, 'Satırdaki çöp kutusu simgesine bastığınızda sistem silmeden önce kategoriyi otomatik kontrol eder. Engel yoksa onay penceresi açılır; "Evet, Sil" ile kategori kalıcı olarak silinir.'),
      tips: [
        t(`${G}.s6.tip1`, 'Kategori kullanımdaysa silinemez ve engelleyen kayıtlar listelenir: alt kategoriler, kategoriye bağlı ürünler, kategorinin eklendiği satış ekranları ve e-ticarete açık olması.'),
        t(`${G}.s6.tip2`, 'Silmek için önce ürünleri başka kategoriye taşıyın veya silin, kategoriyi satış ekranlarının Depo/Stok ayarlarından çıkarın, alt kategorileri silin ve e-ticaret açıksa kapatın.'),
      ],
    },
  ],
});
